import api from '../config/api';
import { AffiliateMetrics } from '../types';

export const affiliateService = {
  // Get affiliate metrics
  getMetrics: async (params?: {
    month?: number;
    year?: number;
  }): Promise<{ success: boolean; data: AffiliateMetrics }> => {
    const response = await api.get('/affiliate/metrics', { params });
    return response.data;
  },
};
